import { getBearerToken } from './auth-token';
import { HttpError } from './round-service';

export interface AccountResponse {
    id: string;
    name: string;
    userId: string;
    authenticated: true;
}

const baseUrl = process.env.REACT_APP_BASE_API_URL!;

const authHeaders = async (): Promise<Record<string, string>> => {
    const token = await getBearerToken();
    if (!token) throw new Error('Not authenticated');
    return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
};

export const provisionAccount = async (): Promise<AccountResponse> => {
    const headers = await authHeaders();
    const res = await fetch(`${baseUrl}/account`, { method: 'POST', headers });
    if (!res.ok) throw new Error(`Provision failed: ${res.status}`);
    return res.json() as Promise<AccountResponse>;
};

export const getAccount = async (): Promise<AccountResponse> => {
    const headers = await authHeaders();
    const res = await fetch(`${baseUrl}/account`, { method: 'GET', headers });
    if (!res.ok) throw new HttpError(res.status, `Get account failed: ${res.status}`);
    return res.json() as Promise<AccountResponse>;
};

export const claimIdentity = async (ephemeralPlayerId: string, roundIds: string[]): Promise<AccountResponse> => {
    const headers = await authHeaders();
    const res = await fetch(`${baseUrl}/account/claim`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ ephemeralPlayerId, roundIds }),
    });
    if (!res.ok) throw new Error(`Claim identity failed: ${res.status}`);
    return res.json() as Promise<AccountResponse>;
};

export interface AccountRound {
    roundId: string;
    roundName: string;
    roundDate: string;
    playerId: string;
    playerName: string;
    status: string;
    updatedAt: string;
}

export const listAccountRounds = async (): Promise<AccountRound[]> => {
    const headers = await authHeaders();
    const res = await fetch(`${baseUrl}/account/rounds`, { method: 'GET', headers });
    if (!res.ok) throw new Error(`List account rounds failed: ${res.status}`);
    const data = (await res.json()) as { rounds: AccountRound[] };
    return data.rounds;
};
